// @flow
import * as React from 'react';
import UserDetailsForm from './UserDetailsForm';
import type { User, UpdateUser, Customer } from '../../types';

type State = {
  isArchiving: boolean,
  isSaving: boolean,
  errorMsg: ?string,
  successMsg?: string
};

type Props = {
  params: Object,
  getUserSettings: Function,
  currentOrganisation: Object,
  currentUser: User,
  updateUser: UpdateUser,
  addUser: (u: any, s: any, c: any) => Promise<*>,
  updateUserInternalAdmin: (u: Object, i: any) => Promise<*>,
  updateCurrentUser: (uid: number) => Promise<*>,
  getAllocatedUserOrganisations: (uid: number, oid: number) => Promise<*>,
  router: Object,
  customers: Array<Customer>
};

class UserDetails extends React.Component<Props, State> {
  timeoutId: any;
  static displayName = 'UserDetails';

  constructor(props: Props) {
    super(props);
    this.state = {
      isArchiving: false,
      isSaving: false,
      errorMsg: undefined
    };
    this.timeoutId = undefined;
  }

  componentDidMount() {
    const organisationId = this.props.params.organisationId;
    this.props.getUserSettings(organisationId);
  }

  componentWillUnmount() {
    // clear timeout to prevent setState on unmounted component
    clearTimeout(this.timeoutId);
  }

  handleSubmit = (values: User) => {
    this.setState({ isSaving: true, errorMsg: undefined });
    const { context } = this.props.params;
    // User cannot be adminUser and not superUser for Customer
    if (context === 'customer' && values.isAdmin && !values.isSuperUser) {
      values.isAdmin = false;
    }
    const settings = this.props.currentOrganisation.userSettings;

    if (values.id) {
      if (context === 'global') {
        this.props.updateUserInternalAdmin(values).then(
          response => this.success(response, false),
          error => this.failure(error)
        );
      } else {
        this.props.updateUser(values, settings, context).then(
          response => this.success(response, false),
          error => this.failure(error)
        );
      }
    } else {
      this.props.addUser(values, settings, context).then(
        response => this.success(response, true),
        error => this.failure(error)
      );
    }
  };

  success = (response: Object, redirect: boolean = false) => {
    if (response.status < 400) {
      this.setState({
        isSaving: false,
        errorMsg: undefined,
        successMsg: 'Success!'
      });
      this.timeoutId = setTimeout(
        () => this.setState({ successMsg: undefined }),
        3000
      );

      if (redirect) {
        const newUserId = response.data.id;
        const organisationId = this.props.currentOrganisation.id;
        this.props.router.push(
          `/customer/${organisationId}/users/${newUserId}`
        );
      } else {
        this.props.updateCurrentUser(
          this.props.currentUser.id,
          this.props.currentOrganisation
            ? this.props.currentOrganisation.id
            : undefined
        );
      }
    } else {
      this.failure(response);
    }
  };

  failure = (error: Object) => {
    this.setState({
      isSaving: false,
      isArchiving: false,
      errorMsg: error.data.message
    });
  };

  archiveUser = (values: Object) => {
    this.setState({ isArchiving: true });
    const { context } = this.props.params;
    const updatedValues = { ...values, isArchived: !values.isArchived };
    if (context === 'global') {
      this.props.updateUserInternalAdmin(updatedValues, true).then(
        response => {
          if (response.status < 400) {
            this.setState({
              isArchiving: false,
              errorMsg: undefined,
              successMsg: 'Success!'
            });
            setTimeout(() => this.setState({ successMsg: undefined }), 3000);
          } else {
            this.failure(response);
          }
        },
        error => this.failure(error)
      );
    } else {
      const userId = this.props.currentUser.id;
      const organisationId = this.props.params.organisationId;

      this.props.deleteUserFromOrganisation(userId, organisationId).then(
        response => {
          if (response.status < 400) {
            this.setState({
              isArchiving: false,
              errorMsg: undefined,
              successMsg: 'Success!'
            });
            setTimeout(() => this.setState({ successMsg: undefined }), 3000);
          } else {
            this.failure(response);
          }
        },
        error => this.failure(error)
      );
    }
  };

  render() {
    const {
      currentUser,
      currentOrganisation,
      customers,
      params: { context }
    } = this.props;
    const isAdmin = !!currentUser.permissions.find(
      p => p.permissionName === 'Admin'
    );
    return (
      <UserDetailsForm
        onSubmit={this.handleSubmit}
        initialValues={{ ...currentUser, isAdmin }}
        enableReinitialize={true}
        currentUser={currentUser}
        currentOrganisation={currentOrganisation}
        archiveUser={this.archiveUser}
        isArchiving={this.state.isArchiving}
        errorMsg={this.state.errorMsg}
        successMsg={this.state.successMsg}
        isSaving={this.state.isSaving}
        context={context}
        customers={customers}
      />
    );
  }
}

export default UserDetails;



// WEBPACK FOOTER //
// ./src/containers/users/UserDetails.js